"use strict";var _this=this;Object.defineProperty(exports,"__esModule",{value:!0}),exports.off=exports.on=void 0;var weex_1=require("./weex");exports.on=function(e,t){weex_1.requireModule("globalEvent").addEventListener(e,function(e){var r={preventDefault:function(){throw new Error("does not support preventDefault")},detail:e};t.call(_this,r)})},exports.off=function(e,t){weex_1.requireModule("globalEvent").removeEventListener(e,t)};


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@3.0.14@dingtalk-jsapi/lib/bridge/weexEvent.js
// module id = 311
// module chunks = 106